import { useEffect, useState } from "react";
import { RuntimeConfig, loadRuntimeConfig, getRuntimeConfig } from "./runtime-config";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { DemoCodeProvider } from "./auth/DemoCodeProvider";
import { Layout } from "./components/Layout";
import { ComingSoon } from "./components/ComingSoon";
import { previewEnabled, syncPreviewFlag } from "./preview";

export function App() {
  const [cfg, setCfg] = useState<RuntimeConfig | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    syncPreviewFlag();
    loadRuntimeConfig().then(setCfg).catch((e) => setErr(String(e)));
  }, []);

  if (err) return <div className="fatal">Failed to load app: {err}</div>;
  if (!cfg) return <div className="loading">Loading…</div>;

  return (
    <AuthProvider cfg={cfg}>
      <DemoCodeProvider>
        <Gate />
      </DemoCodeProvider>
    </AuthProvider>
  );
}

/** Until launch, only the admin (or a `?preview=1` tester) reaches the app;
 *  everyone else — signed in or not — sees the pre-launch splash. The real
 *  access control is server-side; this gate is purely what the browser shows. */
function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Signing in…</div>;
  const adminEmail = getRuntimeConfig().adminEmail?.toLowerCase();
  const isAdmin = !!user?.email && user.email.toLowerCase() === adminEmail;
  if (user && (isAdmin || previewEnabled())) return <Layout />;
  return <ComingSoon />;
}
